import { memo, useEffect, useState } from "react";
import { FormControl } from "react-bootstrap";

function InputCnpj({
    cnpj,
    erro=false,
    validado=false,
    retornarCnpj,
    ...props
}) {
    const [cnpjLocal, alterarCnpjLocal] = useState(cnpj);

    const aoAlterarCnpj = (texto) => {

        // remove qualquer caractere que não seja letra ou número
        let valor = texto
            .replace(/[^A-Za-z0-9]/g, "")
            .toUpperCase()
        ;

        // limita a 14 caracteres (12 + 2 dígitos verificadores)
        valor = valor.slice(0, 14);

        // os dois últimos caracteres devem ser números
        if(valor.length > 12) {
            const base = valor.slice(0, 12);
            const dv = valor
                .slice(12)
                .replace(/\D/g, "");

            valor = base + dv;
        }

        // prepara para formatar
        let formatado = "";

        // percorre e formata
        for(let i = 0; i < valor.length; i++) {
            formatado += valor[i];
            
            if(i === 1 && i < valor.length - 1) {
                formatado += ".";
            }

            if(i === 4 && i < valor.length - 1) {
                formatado += ".";
            }

            if(i === 7 && i < valor.length - 1) {
                formatado += "/";
            }

            if(i === 11 && i < valor.length - 1) {
                formatado += "-";
            }
        }

        // altera com o cnpj formatado
        alterarCnpjLocal(formatado);
    };

    useEffect(() => {
        if(cnpj?.length === 14) {
            aoAlterarCnpj(cnpj);
        }
    }, [])

    useEffect(() => {
        const cnpjLocalLimpo = cnpjLocal.replace(/[^A-Za-z0-9]/g, "");

        // retorna, removendo os caracteres especiais
        if(cnpj !== cnpjLocalLimpo) retornarCnpj(cnpjLocalLimpo);
    }, [cnpjLocal?.length])

    return (
        <FormControl
            className={[
                "form-control",
                (erro) && 'is-invalid',
                (validado) && 'is-valid'
            ].join(' ')}
            placeholder={'__.___.___/____-__'}
            maxLength={18}
            value={cnpjLocal}
            onChange={(e) => aoAlterarCnpj(e.target.value)}
            onPasteCapture={async (e) => {
                e.preventDefault();

                // resgata texto que está colado
                const textoColado = await navigator.clipboard.readText();

                // se não foi uma string copiada
                if(typeof textoColado !== "string") return;

                // manda para alterar
                aoAlterarCnpj(textoColado);
            }}
            {...props}
        />
    )
}

export default memo(InputCnpj)